const RE = /^https:\/\/s\.tabmedifit\.com\//i;

export function rewriteCdnUrlsInData(v: any): any {
    if (v == null) return v;
    if (typeof v === "string") {
        return v.replace(RE, "http://s.tabmedifit.com/");
    }
    if (typeof v !== "object") return v;
    if (Array.isArray(v)) return v.map(rewriteCdnUrlsInData);
    const o: any = {};
    for (const k of Object.keys(v)) {
        o[k] = rewriteCdnUrlsInData(v[k]);
    }
    return o;
}
